export default __webpack_public_path__ + "static/media/gallery_04.3d172e0f.jpg";